import { useState } from 'react'
import { RadioGroup } from '@headlessui/react'
import { CheckCircleIcon } from '@heroicons/react/24/solid'
import { ReactSVG } from 'react-svg';
import { numberFormat } from '../../Utils';

export default function PaymentOptions(props) {
  const [selected, setSelected] = useState({});

  const handleChange = (selected) => {
    if (!props.readonly) {
      setSelected(selected);
      props.onChange(selected);
    }
  }

  return (
    <div className="w-full my-4">
      <div className=" w-full">
        <RadioGroup value={selected} onChange={handleChange}>
          <RadioGroup.Label className="sr-only">Server size</RadioGroup.Label>
          <div className="space-y-2 ">
            {props.plan.map((plan) => (
              <RadioGroup.Option
                key={plan.pg_code}
                value={plan}
                className={({ active, checked }) =>
                  `${active || checked
                    ? 'ring-2 ring-white ring-opacity-60 ring-offset-2 ring-offset-amber-300'
                    : ''
                  }
                  ${active || checked ? 'bg-amber-200 bg-opacity-75' : 'bg-white'
                  }
                    relative text-gray-800 bg-white flex cursor-pointer rounded-lg px-5 py-4 border border-gray-200 rounded-xl focus:outline-none `
                }
              >
                {({ active, checked }) => (
                  <div className="w-full">
                    {/* Top section: name, promo label, check icon */}
                    
                    <div className="flex w-full items-center justify-between">
                      <div className="flex items-center">
                      
                        <div className="text-sm">
                          <RadioGroup.Label
                            as="p"
                            className="text-gray-700 font-semibold"
                          >
                            {/* {plan.pg_name === 'Blu' ? (<img src='logo_blu.png' className='inline-block h-[20px] ml-1' />) : plan.pg_name} */}
                            {plan.pg_name}
                          </RadioGroup.Label>
                        </div>

                        {plan.promo_is_active && (
                          <ReactSVG
                            src={`/bg_label_discount.svg`}
                            afterInjection={(svg) => {
                              svg.setAttribute('height', '24')
                            }}
                            className="ml-0"
                          />
                        )}
                      </div>

                      <div className="shrink-0">
                        {active || checked ? (
                          <CheckCircleIcon className="h-6 w-6 text-amber-500" />
                        ) : (
                          <CheckCircleIcon className="h-6 w-6 text-gray-300" />
                        )}
                      </div>
                    </div>

                    {/* Bottom section: description */}
                    {plan.promo_is_active && <div className="mt-2 text-xs text-gray-500 flex items-start">
                      <img src="/ic_info.png" className="h-4 mr-1" alt="logo blu" />
                      <div>
                        Promo diskon dengan transaksi minimum Rp{numberFormat(plan.min_transaction_amount, false)} atau maksimal diskon Rp{numberFormat(plan.max_discount_amount, false)}. Selama kuota masih ada.
                      </div>
                    </div>
}
                  </div>

                )}
              </RadioGroup.Option>
            ))}
          </div>
          <div>
            {props.plan.length === 0 && (
              <div className="text-gray-500 text-sm mt-2">
                Tidak ada metode pembayaran yang tersedia.
              </div>
            )}
          </div>
        </RadioGroup>
      </div>
    </div>
  )
}


